module.exports = __webpack_public_path__ + "static/media/road.526e08e2.jpg";